/**
 * DF card hover video
 *
 * Lance la vidéo d'une carte produit (.df-card-video) quand la souris survole l'image,
 * la met en pause et la remet au début quand la souris sort.
 * Ne fait rien sur écran tactile. La vidéo n'est téléchargée qu'au premier survol (preload="none").
 */
(function () {
  if (window.__dfCardVideoInit) return;
  window.__dfCardVideoInit = true;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function mediaOf(target) {
    return target && target.closest ? target.closest('.product-card__media') : null;
  }

  document.addEventListener('mouseover', function (e) {
    if (!canHover.matches) return;
    var media = mediaOf(e.target);
    if (!media) return;
    if (e.relatedTarget && media.contains(e.relatedTarget)) return;
    var video = media.querySelector('.df-card-video');
    if (!video) return;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  });

  document.addEventListener('mouseout', function (e) {
    var media = mediaOf(e.target);
    if (!media) return;
    if (e.relatedTarget && media.contains(e.relatedTarget)) return;
    var video = media.querySelector('.df-card-video');
    if (!video) return;
    video.pause();
    try { video.currentTime = 0; } catch (err) {}
  });

  // Les événements média ne remontent pas : on les écoute en phase de capture.
  document.addEventListener('playing', function (e) {
    if (e.target.classList && e.target.classList.contains('df-card-video')) e.target.classList.add('is-playing');
  }, true);

  document.addEventListener('pause', function (e) {
    if (e.target.classList && e.target.classList.contains('df-card-video')) e.target.classList.remove('is-playing');
  }, true);
})();